import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../../services/Api/Admin/adminApi";
import { OrganizationPartnerInfoApi } from "../../../../../../services/Api/Admin/adminTypes";
import { partnerApi } from "../../../../../../services/Api/Partner/partnerApi";
import OrganizationSinglePartnerItem from "./OrganizationSinglePartnerItem";

interface Props {
	isShown: number | undefined;
	onHide: () => void;
	isAdminMode: boolean;
	organizationId: number;
	partnerId?: number;
}

const OrganizationPartnersProvisionsModal = ({ isShown, onHide, isAdminMode, organizationId, partnerId }: Props) => {
	const { t } = useTranslation("admin");
	const { addFlash } = useFlash();
	const [loading, setLoading] = useState<boolean>(false);
	const [partners, setPartners] = useState<OrganizationPartnerInfoApi[]>([]);

	useEffect(() => {
		fetchPartners();
	}, []);

	const fetchPartners = async () => {
		setLoading(true);
		try {
			let res: OrganizationPartnerInfoApi[];
			if (isAdminMode) {
				res = await adminApi.getOrganizationPartners(organizationId);
			} else {
				res = await partnerApi.getOrganizationPartners(Number(partnerId), organizationId);
			}
			setPartners(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
		setLoading(false);
	};

	return (
		<Modal onHide={onHide} show={!!isShown} className="organization-partners-provisions-modal" size="lg">
			<Modal.Header closeButton>
				<Modal.Title>{t("common.word.partners")}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="organization-partners-provisions-modal-body">
				{loading ? (
					<LoadingContainer />
				) : (
					partners.map((partner, index) => (
						<OrganizationSinglePartnerItem
							partner={partner}
							size="large"
							key={`partners-modal-partner-${index}`}
						/>
					))
				)}
			</Modal.Body>
		</Modal>
	);
};

export default OrganizationPartnersProvisionsModal;
